import React, { PropTypes } from 'react'
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap'

const Textarea = ({ id, label, help, error, ...props }) => (
  <FormGroup controlId={id} validationState={error && 'error'}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl componentClass="textarea" {...props} />
    {error && <HelpBlock>{error}</HelpBlock>}
    {help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
)

Textarea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  help: PropTypes.string,
  error: PropTypes.string,
}

export default Textarea



// WEBPACK FOOTER //
// ./src/browser/components/form/Textarea.js